module.exports = __webpack_public_path__ + "img/cloudsCardanoMint.53f77724.png";